import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { TimepickerOptions, TimepickerUI } from "timepicker-ui";
import "timepicker-ui/main.css";

export default class extends Controller {
	connect() {
		console.log('initAirspaceStatesForm');

		const config: Partial<TimepickerOptions> = {
			clock: {
				type: '24h',
				incrementMinutes: 5,
				autoSwitchToMinutes: true
			},
			labels: {
				time: 'Válassz időpontot',
				cancel: 'Mégse'
			},
			behavior: {
				delayHandler: 20
			}
		};

		new TimepickerUI("#airspace_state_active_from", config).create();
		new TimepickerUI("#airspace_state_active_to", config).create();

		refresh();
		$('#airspace_state_status_id').on('change', refresh);

		function refresh() {
			const status_id = $('#airspace_state_status_id').val();
			if (status_id == 5 || status_id == 6) {
				$('.form-group.airspace_state_active_from').show(400);
				$('.form-group.airspace_state_active_to').show(400);
			} else {
				$('.form-group.airspace_state_active_from').hide(400);
				$('.form-group.airspace_state_active_to').hide(400);
			}
		}

	}
}
